module.exports = {"connectProblem":"Waiting for connection..."}